export enum DiscountTypeEnum {
    PERCENTAGE = 1,
    CASH = 2
}
